import { getToken } from '@/utils/auth'
import { webSocketUrl, pn } from '@/common/http'
import store from '@/store'

let socket = null
let lockReconnect = false
const timeout = 30 * 1000
let timeoutObj = null
let serverTimeoutObj = null
let timeoutnum = null
let isManualClose = false

const canConnectWebSocket = () => {
    const token = getToken()
    const uInfo = store.getters.userInfo || {}
    return !!(token && webSocketUrl && uInfo.id && uInfo.salesPersonId)
}

const clearTimers = () => {
    clearTimeout(timeoutObj)
    clearTimeout(serverTimeoutObj)
    clearTimeout(timeoutnum)
}

const initWebSocket = async () => {
    if (!canConnectWebSocket() || !('WebSocket' in window)) {
        return
    }
    isManualClose = false
    const uInfo = store.getters.userInfo
    const wsUrl = webSocketUrl + `?memberInfoId=${uInfo.id}&salesPersonId=${uInfo.salesPersonId}&pn=${pn}`
    socket = new WebSocket(wsUrl)
    socket.onerror = webSocketOnError
    socket.onmessage = webSocketOnMessage
    socket.onclose = closeWebsocket
    socket.onopen = openWebsocket
}

const openWebsocket = () => {
    const uInfo = store.getters.userInfo || {}
    const token = getToken()
    if (token && socket && socket.readyState === 1) {
        socket.send(JSON.stringify({
            token,
            memberInfoId: uInfo.id,
            salesPersonId: uInfo.salesPersonId,
            pn
        }))
    } else if (socket) {
        socket.close()
    }
    start()
}

const start = () => {
    clearTimeout(timeoutObj)
    clearTimeout(serverTimeoutObj)
    timeoutObj = setTimeout(() => {
        if (!socket) return
        if (socket.readyState === 1) {
            const uInfo = store.getters.userInfo || {}
            const token = getToken()
            if (token) {
                socket.send(JSON.stringify({
                    token,
                    memberInfoId: uInfo.id,
                    salesPersonId: uInfo.salesPersonId,
                    pn
                }))
            } else {
                socket.close()
            }
        } else {
            reconnect()
        }
        serverTimeoutObj = setTimeout(() => {
            if (socket) socket.close()
        }, timeout)
    }, timeout)
}

const reconnect = () => {
    if (lockReconnect || isManualClose || !canConnectWebSocket()) {
        return
    }
    lockReconnect = true
    clearTimeout(timeoutnum)
    timeoutnum = setTimeout(() => {
        initWebSocket()
        lockReconnect = false
    }, 10000)
}

const reset = () => {
    clearTimeout(timeoutObj)
    clearTimeout(serverTimeoutObj)
    start()
}

const sendWebsocket = () => {}

const webSocketOnError = () => {
    reconnect()
}

const webSocketOnMessage = (e) => {
    if (getToken()) {
        window.dispatchEvent(
            new CustomEvent('onmessageWS', {
                detail: {
                    data: e?.data
                }
            })
        )
    }
    reset()
}

const closeWebsocket = () => {
    if (!isManualClose) reconnect()
}

const close = () => {
    isManualClose = true
    clearTimers()
    lockReconnect = false
    if (socket) {
        socket.close()
        socket = null
    }
}

export default { initWebSocket, sendWebsocket, webSocketOnMessage, close }
